import { Category } from '@mui/icons-material';
import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

const BarChartSaldoCategoria = ({ categories }) => {
  const maxChars = 40;

  const sortedCategories = [...categories].sort((a, b) => {
    if ((a.saldo >= 0 && b.saldo >= 0) || (a.saldo < 0 && b.saldo < 0)) {
      return a.saldo - b.saldo;
    }
    return a.saldo >= 0 ? 1 : -1;
  });

  const categoryNames = sortedCategories.map((item) => item.nome);
  const originalDelinquencyPercentages = sortedCategories.map((item) => item.valor);
  const delinquencyPercentages = originalDelinquencyPercentages.map((value) => Math.abs(value));

  const truncatedCategoryNames = categoryNames.map((name) =>
    name.length > maxChars ? name.substring(0, maxChars) + '...' : name.replace(/[^\p{L}\s]/gu, '')
  );

  const option = {
    title: {
      text: 'Saídas e Entradas por grupo de categoria',
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (params) => {
        let tooltipContent = '';
        params.forEach((param, index) => {
          const categoryName = categoryNames[param.dataIndex];
          const value = Math.trunc(originalDelinquencyPercentages[param.dataIndex]).toLocaleString('pt-BR');

          tooltipContent += `
            <div> Categoria: ${categoryName} </div>
            <div> Saldo: R$ ${value} </div>
          `;
        });
        return tooltipContent;
      },
    },
    legend: {
      data: [
        { name: 'Saldo positivo', icon: 'circle' },
      ],
      right: '0',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
    },
    yAxis: {
      type: 'category',
      data: truncatedCategoryNames,
      axisLabel: {
      formatter: (value) => value.length > 20 ? value.slice(0, 20) + '\n' + value.slice(20) : value,
        width: 200,
        overflow: 'truncate',
        ellipsis: '...',
      },
    },
    series: [
      {
        name: 'Inadimplência',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: (params) => `R$ ${Math.trunc(params.value as number).toLocaleString('pt-BR')}`,
        },
        itemStyle: {
          color: (params) => {
            return originalDelinquencyPercentages[params.dataIndex] < 0 ? '#ff0000' : '#00ff00';
          },
        },
        emphasis: {
          focus: 'series',
        },
        data: delinquencyPercentages,
      },
    ],
  } as ChartOption;

  const chartHeight = Math.max(400, sortedCategories.length * 30); // 30px por categoria

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', padding: '20px 10px 0 10px' }} height={`${chartHeight}px`}>
      <Chart option={option} />
    </Box>
  );
};

export default BarChartSaldoCategoria;